var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultPhoto(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_262",
    "data-name": "Grupo 262",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101.105,
    height: 101.073,
    viewBox: "0 0 101.105 101.073",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rect\\xE1ngulo_327",
    "data-name": "Rect\\xE1ngulo 327",
    width: 101.105,
    height: 101.073,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_261",
    "data-name": "Grupo 261",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_661",
    "data-name": "Trazado 661",
    d: "M101.105,23.162c-.215,1.02-.4,2.046-.648,3.056A21.074,21.074,0,0,1,90.37,39.849c-.209.124-.417.254-.7.429,4.2,13.512,3,26.489-4.346,38.687A44.7,44.7,0,0,1,63.874,97.474a45.884,45.884,0,0,1-52.143-11.78C-1.762,70.223-3.8,49.043,6.573,31.475a45.031,45.031,0,0,1,14.3-14.885,45.4,45.4,0,0,1,19.337-7.14,46.468,46.468,0,0,1,20.336,1.912A54.357,54.357,0,0,1,65,6.073C71.333.2,78.778-1.52,86.9,1.38s12.708,8.974,14.018,17.5a6.6,6.6,0,0,0,.189.7ZM71.893,84.517a1.569,1.569,0,0,0,.3-.162c.364-.33.732-.657,1.075-1.006,11.1-11.331,14.466-24.656,10.314-39.929-.181-.663-.412-.993-1.217-.866a19.286,19.286,0,0,1-7.5-.38A21.318,21.318,0,0,1,58.584,18.631c.079-.592-.068-.915-.683-1.042a73.971,73.971,0,0,0-7.29-1.511A38.64,38.64,0,0,0,18.745,26.883c-16.171,15.335-15.908,41.853.528,56.9.189.173.412.31.682.508A21.067,21.067,0,0,1,27.235,73.7c8.446-6.568,17.919-7.942,28.014-4.933A24.034,24.034,0,0,1,70.725,81.592c.454.938.777,1.939,1.168,2.925m-25.9,9.827a39.256,39.256,0,0,0,18.849-4.759,1.4,1.4,0,0,0,.836-1.743,14.781,14.781,0,0,0-6.5-9.8,24.1,24.1,0,0,0-26.021-.416c-3.69,2.422-6.283,5.636-7.094,10.106a1.268,1.268,0,0,0,.736,1.586,39.2,39.2,0,0,0,19.194,5.024m48.365-72.9A14.722,14.722,0,0,0,79.77,6.8,14.582,14.582,0,1,0,94.353,21.446",
    transform: "translate(0 0.001)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_662",
    "data-name": "Trazado 662",
    d: "M54.507,40.206A15.966,15.966,0,1,1,38.68,24.168,16,16,0,0,1,54.507,40.206m-6.739,0a9.227,9.227,0,1,0-9.21,9.224,9.231,9.231,0,0,0,9.21-9.224",
    transform: "translate(7.318 7.835)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_663",
    "data-name": "Trazado 663",
    d: "M66.022,15.152c1.122,0,2.1-.012,3.075,0a3.412,3.412,0,0,1,3.616,3.412,3.355,3.355,0,0,1-3.577,3.316c-.977.015-1.956,0-3.128,0,0,1.274.037,2.487-.009,3.694a3.321,3.321,0,0,1-6.267,1.386,5.386,5.386,0,0,1-.426-1.92c-.068-1.005-.017-2.018-.017-3.162-1.11,0-2.115.013-3.12,0a3.42,3.42,0,0,1-3.606-3.316A3.482,3.482,0,0,1,56.2,15.155c.976-.013,1.952,0,3.092,0,0-1.11-.04-2.146.008-3.179a3.45,3.45,0,0,1,2.937-3.341,3.318,3.318,0,0,1,3.554,2.2,6.261,6.261,0,0,1,.22,1.753c.036.8.009,1.6.009,2.572",
    transform: "translate(17.039 2.788)",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultPhoto);
export default __webpack_public_path__ + "static/media/default-photo.5f101ef5bb3fd7ff4dca3f4adb80e417.svg";
export { ForwardRef as ReactComponent };